// @flow
import get from 'lodash/get';
import breadcrumbMapper from './breadcrumbMapper';
import searchAdsLinksMapper from './linksMapper';
import type { InterlinkingType } from '../../../types/interlinking';

const keysToMap = {
  firstOption: [
    {
      from: 'anchor',
      to: 'text',
    },
    {
      from: 'url',
      to: 'path',
    },
  ],
  secondOption: [
    {
      from: 'name',
      to: 'text',
    },
    {
      from: 'url',
      to: 'path',
    },
  ],
  thirdOption: [
    {
      from: 'type',
      to: 'link',
    },
    {
      from: 'anchor',
      to: 'value',
    },
  ],
};

export default function map(responseApiSearchAdsKeywords: Object): InterlinkingType {
  const interlinking = {
    similar: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'similarKeywords'),
      keysToMap.secondOption
    ),
    breadcrumb: breadcrumbMapper(get(responseApiSearchAdsKeywords, 'breadcrumb')),
    geo: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.geo'),
      keysToMap.firstOption
    ),
    condition: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.condition'),
      keysToMap.firstOption
    ),
    geo_horizontal: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.geoHorizontal'),
      keysToMap.firstOption
    ),
    fuel: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.fuel'),
      keysToMap.firstOption
    ),
    model: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.model'),
      keysToMap.firstOption
    ),
    selected_seo_links: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.current'),
      keysToMap.thirdOption
    ),
    amenities: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.amenities'),
      keysToMap.secondOption
    ),
    property_type: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.propertyType'),
      keysToMap.firstOption
    ),
    oldLocation: {
      region: searchAdsLinksMapper(
        get(responseApiSearchAdsKeywords, 'hierarchy.region'),
        keysToMap.firstOption
      ),
      city: searchAdsLinksMapper(
        get(responseApiSearchAdsKeywords, 'hierarchy.city'),
        keysToMap.firstOption
      ),
    },
    otherJobCategories: searchAdsLinksMapper(
      get(responseApiSearchAdsKeywords, 'hierarchy.subcategory'),
      keysToMap.firstOption
    ),
  };

  return interlinking;
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchResponse/common/interlinkingMapper.js